import { muiStyles } from 'utils/design';

export const useStyles = muiStyles(() => ({
  box: {
    display: 'flex',
    flexGrow: 1,
  },
}));
